import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PrivacyPolicyPage.css';

const logoUrl = `${process.env.PUBLIC_URL || ''}/logo.png`;

function PrivacyPolicyPage() {
  return (
    <div className="legal-page privacy-policy-page">
      <header className="legal-page-header">
        <div className="legal-page-logo">
          <Link to="/" aria-label="Frame-Book Home">
            {logoUrl && <img src={logoUrl} alt="Frame-Book" className="legal-page-logo-img" />}
          </Link>
        </div>
        <h1 className="legal-page-title">Privacy Policy</h1>
        <Link to="/" className="legal-page-back">
          Back to home
        </Link>
      </header>
      <div className="legal-page-content">
        <iframe
          src="/documents/Frame-Book_Privacy_StructureBased_v2.pdf#toolbar=0"
          title="Privacy Policy"
          className="legal-page-iframe"
        />
        <p className="legal-page-fallback">
          <a href="/documents/Frame-Book_Privacy_StructureBased_v2.pdf" target="_blank" rel="noopener noreferrer">
            Open Privacy Policy (PDF) in new tab
          </a>
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
